import { FUEL_TYPES } from 'config/app-config';
import { useMaskPII } from 'hooks/useMaskPII';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsInput } from 'components/common/ns-input/NsInput';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type NsConsumptionInputProps = {
  fuelType: typeof FUEL_TYPES[keyof typeof FUEL_TYPES]; //TODO: review required here
  value?: number | string;
  onChange?: (event: NsInputterEvent) => void;
};

export const NsConsumptionInput = ({
  fuelType,
  onChange,
  value
}: NsConsumptionInputProps) => {
  const label =
    fuelType === FUEL_TYPES.ELECTRIC
      ? 'Electricity usage (kWh)'
      : 'Gas usage (kWh)';
  const { unmask } = useMaskPII();
  const validations = [
    NsInputterValidations.isRequired,
    NsInputterValidations.isInteger,
    NsInputterValidations.minLength(2),
    NsInputterValidations.maxLength(6)
  ];

  return (
    <NsInputter
      onChange={onChange}
      validation={validations}
      value={value}
      name={fuelType}
    >
      <NsInput
        id={fuelType}
        name={fuelType}
        label={label}
        inputAttributes={unmask}
        pattern="^[1-9][0-9]{1,5}$" // greater than 9, no leading 0s
      />
    </NsInputter>
  );
};
